import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import api from "../lib/api";

export default function Home() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ professionals: 0, rating: 4.8 });

  useEffect(() => {
    api.get("/profiles").then(({ data }) => {
      const total = data.length;
      const avg = data.length ? (data.reduce((s, p) => s + (p.rating || 0), 0) / data.length) : 4.8;
      setStats({ professionals: total, rating: Math.round(avg * 10) / 10 });
    }).catch(() => {});
  }, []);

  return (
    <div className="space-y-6 animate-fade-in-up">
      <div>
        <p className="text-slate-500">Hola,</p>
        <h1 className="text-2xl md:text-4xl font-extrabold text-slate-900" data-testid="welcome-name">{user?.name || ""}</h1>
      </div>

      <div>
        <h2 className="text-xl md:text-2xl font-extrabold text-slate-900">Encuentra canguros y profesores cerca de ti en minutos</h2>
        <p className="text-slate-500 mt-1">¿Qué estás buscando hoy?</p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <Link to="/profiles/canguro" data-testid="category-canguros-card"
          className="relative overflow-hidden rounded-3xl p-6 md:p-8 text-white bg-gradient-to-br from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 transition group min-h-[200px] flex flex-col justify-between">
          <div className="w-12 h-12 rounded-xl bg-white/25 backdrop-blur flex items-center justify-center">
            <i className="fa-solid fa-heart text-white text-2xl"></i>
          </div>
          <div>
            <h3 className="text-3xl md:text-4xl font-extrabold">Canguros</h3>
            <p className="text-white/85 mt-1">Encuentra cuidadores de confianza para tus hijos</p>
          </div>
          <div className="absolute bottom-6 right-6 w-10 h-10 rounded-full bg-white/25 backdrop-blur flex items-center justify-center group-hover:translate-x-1 transition">
            <i className="fa-solid fa-arrow-right text-white"></i>
          </div>
        </Link>

        <Link to="/profiles/profesor" data-testid="category-profesores-card"
          className="relative overflow-hidden rounded-3xl p-6 md:p-8 text-white bg-gradient-to-br from-teal-400 to-teal-600 hover:from-teal-500 hover:to-teal-700 transition group min-h-[200px] flex flex-col justify-between">
          <div className="w-12 h-12 rounded-xl bg-white/25 backdrop-blur flex items-center justify-center">
            <i className="fa-solid fa-graduation-cap text-white text-2xl"></i>
          </div>
          <div>
            <h3 className="text-3xl md:text-4xl font-extrabold">Profesores</h3>
            <p className="text-white/85 mt-1">Profesores particulares para refuerzo y más</p>
          </div>
          <div className="absolute bottom-6 right-6 w-10 h-10 rounded-full bg-white/25 backdrop-blur flex items-center justify-center group-hover:translate-x-1 transition">
            <i className="fa-solid fa-arrow-right text-white"></i>
          </div>
        </Link>
      </div>

      <div className="flex flex-wrap items-center gap-6 text-sm text-slate-600">
        <div className="flex items-center gap-2"><i className="fa-solid fa-location-dot text-blue-600"></i> Cerca de ti en tu ciudad</div>
        <div className="flex items-center gap-2"><i className="fa-solid fa-comments text-amber-500"></i> Chat directo</div>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <div className="kibli-card text-center py-5">
          <div className="text-2xl md:text-3xl font-extrabold text-slate-900" data-testid="stat-professionals">{stats.professionals}+</div>
          <div className="text-xs md:text-sm text-slate-500 mt-1">Profesionales</div>
        </div>
        <div className="kibli-card text-center py-5">
          <div className="text-2xl md:text-3xl font-extrabold text-slate-900" data-testid="stat-rating">{stats.rating}</div>
          <div className="text-xs md:text-sm text-slate-500 mt-1">Valoración media</div>
        </div>
        <div className="kibli-card text-center py-5">
          <div className="text-2xl md:text-3xl font-extrabold text-slate-900">España</div>
          <div className="text-xs md:text-sm text-slate-500 mt-1">Tu ciudad</div>
        </div>
      </div>
    </div>
  );
}
